/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  ManagerLogic4,
  ManagerLogic4Interface,
} from "../../../contracts/manager/ManagerLogic4";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtCost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "earlyAccessIds",
        type: "uint256[]",
      },
    ],
    name: "BuyEarlyAccess",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "GetInvestmentReward",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bonus",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stfToSelf",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stfToDead",
        type: "uint256",
      },
    ],
    name: "GetReward",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtAll",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "zbcUsdtPrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtCost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "zbcCost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "investmentCredentialId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "Invest",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtToColdWallet",
        type: "uint256",
      },
    ],
    name: "RedeemUsds",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "inviter",
        type: "address",
      },
    ],
    name: "Register",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usds",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "power",
        type: "uint256",
      },
    ],
    name: "Stake",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "UsdtPurchaseUsds",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usds",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsToBurn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "power",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketNumber",
        type: "uint256",
      },
    ],
    name: "WithdrawPromotionUsds",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "stakeTimespan",
        type: "uint256",
      },
    ],
    name: "_determineApy",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "lp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lpUsdtPrice",
        type: "uint256",
      },
    ],
    name: "_lpToUsd",
    outputs: [
      {
        internalType: "uint256",
        name: "usd",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "usd",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stfUsdtPrice",
        type: "uint256",
      },
    ],
    name: "_usdToStf",
    outputs: [
      {
        internalType: "uint256",
        name: "stf",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "usdtStfLpAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "usdsStfLpPrice",
        type: "uint256",
      },
    ],
    name: "_usdsStfLpToUsd",
    outputs: [
      {
        internalType: "uint256",
        name: "usd",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "lpPriceFixedPoint18",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "timestamp",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.LpPriceParam",
        name: "param",
        type: "tuple",
      },
    ],
    name: "calcLpPriceParamDigest",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLpPriceParamTypeHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stfPriceFixedPoint18",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "timestamp",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.StfPriceParam",
        name: "param",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
        ],
        internalType: "struct ManagerType.Signature",
        name: "signature",
        type: "tuple",
      },
      {
        internalType: "uint256[]",
        name: "bills",
        type: "uint256[]",
      },
    ],
    name: "lpGetReward",
    outputs: [
      {
        internalType: "uint256",
        name: "stfReward",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "lpPriceFixedPoint18",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "timestamp",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.LpPriceParam",
        name: "param",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
        ],
        internalType: "struct ManagerType.Signature",
        name: "signature",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "lpAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stakeTimespan",
        type: "uint256",
      },
    ],
    name: "lpStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "bills",
        type: "uint256[]",
      },
    ],
    name: "lpWithdraw",
    outputs: [
      {
        internalType: "uint256",
        name: "allUsdtAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "allStfToSelf",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "inviterUp1",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "allStfToInviter1",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "inviterUp2",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "allStfToInviter2",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type ManagerLogic4ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ManagerLogic4ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ManagerLogic4__factory extends ContractFactory {
  constructor(...args: ManagerLogic4ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ManagerLogic4> {
    return super.deploy(overrides || {}) as Promise<ManagerLogic4>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ManagerLogic4 {
    return super.attach(address) as ManagerLogic4;
  }
  override connect(signer: Signer): ManagerLogic4__factory {
    return super.connect(signer) as ManagerLogic4__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ManagerLogic4Interface {
    return new utils.Interface(_abi) as ManagerLogic4Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ManagerLogic4 {
    return new Contract(address, _abi, signerOrProvider) as ManagerLogic4;
  }
}
